export enum UploadSourceType {
    UPLOAD = 'upload',
    LOCAL_MEDIA = 'localMedia',
    EUDIW = 'eudiw'
}

/**
 * Narrows a raw value — provided by the server configuration or by a component attribute —
 * to a known {@link UploadSourceType}. Everything else is not a source this application
 * knows how to offer and is dropped by the callers.
 */
export function isUploadSourceType( value: string ): value is UploadSourceType {
    return ( Object.values( UploadSourceType ) as string[] ).includes( value );
}
